module.exports = __webpack_public_path__ + "img/bg3.6d371969.jpg";